export enum StrikingRuneLevelNames {
    None = '',
    Normal = 'Striking',
    Greater = 'Greater Striking',
    Major = 'Major Striking',
}

export enum ResilientRuneLevelNames {
    None = '',
    Normal = 'Resilient',
    Greater = 'Greater Resilient',
    Major = 'Major Resilient',
}
